import { render } from "./individual-exclusion-form.vue?vue&type=template&id=2341d852"
import script from "./individual-exclusion-form.vue?vue&type=script&lang=js"
export * from "./individual-exclusion-form.vue?vue&type=script&lang=js"

import "./individual-exclusion-form.vue?vue&type=style&index=0&id=2341d852&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__